import { Divider, Form, InputNumber, Progress, Select, Spin } from "antd";
import React, { useRef } from "react";
import { useSelector } from "react-redux"; 
import svg87 from "../../../../assets/svg/svg87.svg"; 
import svg88 from "../../../../assets/svg/svg88.svg";
import { tierData } from "../../../../data";
import PathwayData from "./PathwayData";
import { cashConverter } from "../../../../utils";
import InvestmentBreakdown from "./InvestmentBreakdown";

function BreakDown({ handleNext, handleBack }) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const {activeObj} =  useSelector((state)=>state.obj)
  const handleSubmit = async (data) => {
    await handleNext();
  };
 

  return (
    <div>
      <div className="flex flex-col lg:px-[5rem] px-3">
        <div className="text-[#1A1A1A] font-sora text-[1.25rem] font-[400] leading-[1.5rem]   w-full lg:mb-[2.5rem] mb-[1rem] items-center text-center justify-center">
          Investment Breakdown
        </div>

        <div className="mt-[1rem] bg-[#F1F3F5] flex lg:flex-row flex-col lg:items-center lg:gap-0 gap-5 lg:justify-between lg:p-[2rem] p-[1rem] rounded-[1rem] lg:mb-[2rem] mb-[1rem]">
          <div className="flex flex-col">
            <div className="text-[#1A1A1A] text-[.75rem] font-sora font-[400]">
              Investment Amount:
            </div>
            <div className="text-[#0092CC] mt-[1.75rem] text-[1rem] font-[600]">
             {cashConverter(activeObj?.invAmount)}
            </div>
          </div>

          <div className="flex flex-col">
            <div className="text-[#1A1A1A] text-[.75rem] font-sora font-[400]">
              Pathway
            </div>
            <div className="text-[#0092CC] mt-[1.75rem] text-[1rem] font-[600]">
              Expanded FLID Analysis
            </div>
          </div>
        </div>

        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={handleSubmit}
          className="lg:w-[30%] w-full"
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            name="bankName"
            label={"Select Investment Type"}
            rules={[
              {
                required: true,
                message: "Please Select Investment Type",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                tierData?.length > 0 &&
                tierData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item> 
        </Form>

       <PathwayData/>
       <InvestmentBreakdown/>

        <div className="sticky lg:mb-[6.25rem] mb-[3rem] left-0 w-full lg:mt-[3.75rem] mt-[1rem] ">
          <Divider />
          <div className="flex justify-between items-center mt-[1rem] gap-x-[1.25rem]">
            <button
              onClick={handleBack}
              type="button"
              key="back"
              className="flex items-center gap-[1rem]"
            >
              <img src={svg88} alt="svg88" /> Previous
            </button>

         
              <button
                onClick={handleSubmit}
                disabled={saving}
                type="button"
                className="cstm-btn-2 !w-fit"
              >
                {saving ? (
                  <Spin />
                ) : (
                  <>
                    View Full Summary Report <img src={svg87} alt="svg87" />
                  </>
                )}
              </button> 
          </div>
        </div>
      </div>
    </div>
  );
}

export default BreakDown;
